import { render, staticRenderFns } from "./SubEdit.vue?vue&type=template&id=226d4870"
import script from "./SubEdit.vue?vue&type=script&lang=js"
export * from "./SubEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports